import React, {Component, PropTypes} from 'react'
import {Time} from './time'
import _ from 'lodash'
import cx from 'classnames'

function wrap(codes) {
  const codesString = codes;
  const object = _.template(codesString)
  return object
}

const tableCodes = {
  // TODO only show if you invited the person
  100: wrap('<b>${subject.name || source._profile.name}</b> joined Table <b>${object.title || source._object.title}</b>'),
  101: wrap('<b>${subject.name || source._owner.name}</b> invited you to <b>${object.title || source._object.title}</b>'),
  102: wrap('You have left Table <b>${object.title || source._object.title}</b>'),
  103: wrap('You moved a Table to <b>${object.title || source.title}</b>'),
  104: wrap('<b>${subject.name || source._owner.name}</b> updated the Description of <b>${object.title || source.title}</b>'),
  105: wrap('<b>${subject.name || source._profile.name}</b> archived <b>${object.title || source._table.title}</b>'),
  106: wrap('You created the Room <b>${object.title || source.title}</b>'),
  107: wrap('You deleted the Room <b>${object.title || source.title}</b>'),
  108: wrap('<b>${subject.name || source._profile.name}</b> was promoted to co-host in <b>${object.title || source._object.title}</b>'),
  116: wrap('<b>${subject.name || source._profile.name}</b> has requested access to <b>${object.title || source._object.title}</b>'),
  117: wrap('Your request to join <b>${(object.title || source._object.title).trim()}</b> has been approved'),
}

const contactCodes = {
  114: wrap('You added <b>${object.name || source._profile.name}</b> to your contacts'),
  115: wrap('You deleted <b>${object.name || source._profile.name}</b> from your contacts'),
}

const userCodes = {
  200: wrap('<b>${subject.name || source._profile.name}</b> logged in'),
  201: wrap('<b>${subject.name || source._profile.name}</b> account created'),
  202: wrap('<b>${subject.name || source._profile.name}</b> logged out'),
  203: wrap('<b>${subject.name || source._profile.name}</b> settings updated'),
  204: wrap('You have verified your email address'),
}

const profileCodes = {
  300: wrap('<b>${subject.id || source._profile.id}</b> updated'),
};

const messageCodes = {
  402: wrap('You have highlighted a message'),
  403: wrap('<b>${subject.name || source._profile.name}</b> has highlighted your message'),
}

const privateCodes = {
  500: wrap('<b>${subject.name || source._profile.name || source._owner.name}</b> mentioned you in <b>${object.title || source._table.title}</b>'),
  501: wrap('<b>${subject.name || source._profile.name}</b> sent you a private message'),
}

const fileCodes = {
  600: wrap('<b>${object.id || source.piece.id}</b> uploaded'),
  601: wrap('<b>${object.id || source.piece.id}</b> uploaded'),
  602: wrap('<b>${object.id || source.piece.id}</b> deleted'),
}

const messages = _.assign({},
  tableCodes,
  contactCodes,
  userCodes,
  profileCodes,
  messageCodes,
  privateCodes,
  fileCodes
)

export class Notification extends Component {
  static propTypes = {
    notification: PropTypes.object.isRequired,
    subject: PropTypes.object,
    object: PropTypes.object,
    link: PropTypes.string,
    hasNext: PropTypes.bool,
    hasPrevious: PropTypes.bool
  }

  static defaultProps = {
    subject: {},
    object: { title: 'title' }
  }

  render () {
    const { notification, subject, object, link, hasNext, hasPrevious } = this.props
    const __html =
            messages[notification.code] &&
            messages[notification.code](_.assign({ subject, object }, notification))

    return (
      <a className={cx('notification', 'list-item', 'm--border', { 'm--has-previous': hasPrevious, 'm--has-next': hasNext })} href={link}>
        <div
          className="list-item__avatar"
          style={{backgroundImage: subject.avatarUrl && 'url('+subject.avatarUrl+')'}}
        />
        <div className="list-item__content">
          <span dangerouslySetInnerHTML={{ __html }} />
        </div>
        <div className="list-item__extra">
          <Time time={notification.created} format='time'/>
          {_.includes([101, 116], notification.code) &&
            <div className="notification__options">
              <span className="icon-accept"/>
              <span className="icon-trash"/>
              <span className="icon-close"/>
            </div>
          }
        </div>
      </a>
    );
  }
}
